import { useQuery } from 'react-query';

// app
import { adminAxios } from 'lib/admin/admin.api';
import { OPERATIONAL_MARKET_DETAIL } from 'lib/admin/queryKeys';
import * as utils from 'utils';
import { logoutAuth0 } from 'utils/auth0/auth0';

export const useGetOperationalMarketDetails = (id) => {
  const handleError = (err) => {
    const errorParams = {
      file: 'admin.queries.useGetOperationalMarketDetails',
    };

    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
  };

  return useQuery(
    [OPERATIONAL_MARKET_DETAIL, id],
    async () => {
      const result = await adminAxios.get(`marketParent/${id}`);

      return result?.data;
    },
    {
      onError: (err) => handleError(err),
      keepPreviousData: true,
    }
  );
};
